// Unpublished Work © 2025 Deere & Company.

/**
 * Polyfill for Object.hasOwn
 *
 * Object.hasOwn was introduced in ES2022 and is not supported in older browsers.
 * This polyfill fixes the "Object.hasOwn is not a function" error that occurs
 * when dependencies (like component libraries) use this newer method.
 *
 * Object.hasOwn is a safer alternative to Object.prototype.hasOwnProperty.call()
 * as it works even when objects don't inherit from Object.prototype.
 *
 * See more details of the error:
 * https://johndeere-isg.datadoghq.com/error-tracking/issue/b25e9ef0-0e3c-11f0-97f4-da7ad0900002?query=&index=&from_ts=1758119179612&to_ts=1758205579612&live=true
 */
if (!Object.hasOwn) {
    Object.defineProperty(Object, 'hasOwn', {
        value: function (object: any, property: string | symbol) {
            if (object == null) {
                throw new TypeError(
                    'Cannot convert undefined or null to object',
                );
            }
            return Object.prototype.hasOwnProperty.call(
                Object(object),
                property,
            );
        },
        configurable: true,
        writable: true,
    });
}
